module.exports = __webpack_public_path__ + "img/btn_google.a3fd961a.png";